import api from "app/api";
import { Options } from "common";
import { DbFile } from "common/types";
import { PartnerItem } from "features/partners/partnerApi";

export interface UserItem {
  id: number;
  first_name: string;
  last_name?: string | null;
  name: string;
  email: string;
  phone?: string;
  password_hash: string;
  login_at: string;
  file: DbFile;
  file_id: number;
  settings: any;
  active: boolean;
  role_ids: number[];
  partner_id?: number;
  partner?: PartnerItem;
}

export type UserOptions = Options<"role" | "status" | "partner">;

export function getUserService(scope?: any) {
  return api.getService<UserItem, UserItem, UserOptions>("users", {
    scope,
    //params goes here
  });
}
